import { render, staticRenderFns } from "./sucesstip.vue?vue&type=template&id=c525a8ea&scoped=true"
import script from "./sucesstip.vue?vue&type=script&lang=ts"
export * from "./sucesstip.vue?vue&type=script&lang=ts"
import style0 from "./sucesstip.vue?vue&type=style&index=0&id=c525a8ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c525a8ea",
  null
  
)

export default component.exports